import { render, staticRenderFns } from "./Solve.vue?vue&type=template&id=321d6544"
import script from "./Solve.vue?vue&type=script&lang=js"
export * from "./Solve.vue?vue&type=script&lang=js"
import style0 from "./Solve.vue?vue&type=style&index=0&id=321d6544&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports